module.exports = __webpack_public_path__ + "img/dabiao_20W.4fce39ee.png";